"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Encapsulates binding of product and site, it is not bound to specific use case, use this as data transfer object.
 *
 * @author JMe
 */


var ProductGroupOfSitesTuple =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductGroupOfSitesTuple, _DomainObject_1$Domai);

  /**
   * @param productId An identification of a {@link Product product}.
   * @param siteId An identification of a {@link GroupOfSites group of sites}.
   */
  function ProductGroupOfSitesTuple(productId, groupOfSitesId) {
    var _this;

    _classCallCheck(this, ProductGroupOfSitesTuple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductGroupOfSitesTuple).call(this));
    _this.productId = productId;
    _this.groupOfSitesId = groupOfSitesId;
    return _this;
  }

  _createClass(ProductGroupOfSitesTuple, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductGroupOfSitesTuple) {
        return other.productId === this.productId && other.groupOfSitesId === this.groupOfSitesId;
      }

      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.productId + '-' + this.groupOfSitesId);
    }
  }]);

  return ProductGroupOfSitesTuple;
}(DomainObject_1.DomainObject);

exports.ProductGroupOfSitesTuple = ProductGroupOfSitesTuple;